import { useMutation } from '@tanstack/react-query';

import { Groups } from '@app/client';

/**
 * React Hook using React Query useMutation to
 * Accept invite using a code
 */
export function useAcceptInviteByCode() {
    return useMutation((inviteCode: string) => Groups.callAcceptInviteByCode(inviteCode));
}
